import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWarrantyListQueryVariables = Types.Exact<{
  market: Types.Scalars['String']['input'];
  startDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  status: Types.Scalars['String']['input'];
  searchText?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetWarrantyListQuery = { __typename?: 'Query', warrantyList: Array<{ __typename?: 'WarrantyListResponse', applicationId: any, applicationNo: string, applicationDate: string, accountNo: string, categoryNames: string, status: string, itemQty: number }> };


export const GetWarrantyListDocument = gql`
    query GetWarrantyList($market: String!, $startDate: String, $endDate: String, $status: String!, $searchText: String) {
  warrantyList(
    parameter: {market: $market, startDate: $startDate, endDate: $endDate, status: $status, searchText: $searchText}
  ) {
    applicationId
    applicationNo
    applicationDate
    accountNo
    categoryNames
    status
    itemQty
  }
}
    `;

/**
 * __useGetWarrantyListQuery__
 *
 * To run a query within a React component, call `useGetWarrantyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyListQuery({
 *   variables: {
 *      market: // value for 'market'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetWarrantyListQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantyListQuery, GetWarrantyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyListQuery, GetWarrantyListQueryVariables>(GetWarrantyListDocument, options);
      }
export function useGetWarrantyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyListQuery, GetWarrantyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyListQuery, GetWarrantyListQueryVariables>(GetWarrantyListDocument, options);
        }
export type GetWarrantyListQueryHookResult = ReturnType<typeof useGetWarrantyListQuery>;
export type GetWarrantyListLazyQueryHookResult = ReturnType<typeof useGetWarrantyListLazyQuery>;
export type GetWarrantyListQueryResult = Apollo.QueryResult<GetWarrantyListQuery, GetWarrantyListQueryVariables>;